import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";

export default function VerifyCertificate() {
  const { id } = useParams();
  const [cert, setCert] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/mitigation/certificates/${id}`).then((r) => setCert(r.data)).catch(() => setErr("Certificate not found."));
  }, [id]);

  return (
    <Layout>
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
        <div className="label-tag mb-4">Public verification</div>
        <h1 className="font-serif text-4xl tracking-tight" data-testid="verify-id">{id}</h1>

        {err && <div className="text-danger mt-6" data-testid="verify-error">{err}</div>}

        {cert && (
          <div className="border border-ink mt-8 bg-surface" data-testid="verify-card">
            <div className="p-6 border-b border-line bg-muted/40 flex items-center justify-between">
              <div>
                <div className="label-tag text-leaf">VERIFIED · STATUS: {cert.status?.toUpperCase()}</div>
                <div className="font-serif text-3xl mt-1">{cert.tons_retired} tCO₂ retired</div>
              </div>
              <div className="text-xs font-mono text-ink2 text-right">
                Issued<br />{new Date(cert.issued_at).toLocaleString()}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line">
              <Row k="Beneficiary" v={cert.beneficiary} />
              <Row k="Purpose" v={cert.purpose} />
              <Row k="Project" v={cert.project_name} />
              <Row k="Producer" v={cert.producer} />
              <Row k="Property" v={cert.property_name} />
              <Row k="Region" v={cert.region} />
              <Row k="Vintage" v={cert.vintage} />
              <Row k="Certifier" v={cert.certifier} />
              <Row k="Audit firm" v={cert.audit_firm} />
              <Row k="CPR Verde" v={cert.cpr_number} mono />
              <Row k="BMV Unit ID" v={cert.bmv_unit_id} mono />
              <Row k="Blockchain tx" v={cert.blockchain_tx} mono />
            </div>
            <div className="p-5 text-xs font-mono text-ink2 border-t border-line">
              ISSUED ON GREENBELT · PROVENANCE ANCHORED TO BMV GLOBAL UCS REGISTRY
            </div>
          </div>
        )}
      </section>
    </Layout>
  );
}

function Row({ k, v, mono }) {
  return (
    <div className="bg-surface p-4">
      <div className="label-tag">{k}</div>
      <div className={`mt-1 text-sm ${mono ? "font-mono" : ""}`}>{v || "—"}</div>
    </div>
  );
}
